import { Alert } from '@creditornot/cb-alert';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useRetailContext } from 'common/hooks';

import { Role } from './types';

type Props = {
  role: Role;
};

const getRoleDescription = (role: Role, shouldUseRetailStrings: boolean) => {
  switch (role) {
    case 'merchant_owner':
      return (
        <FormattedMessage
          id={
            shouldUseRetailStrings
              ? 'userManagement.merchantOwnerDescriptionRetail'
              : 'userManagement.merchantOwnerDescription'
          }
        />
      );
    case 'venue_manager':
      return (
        <FormattedMessage
          id={
            shouldUseRetailStrings
              ? 'userManagement.venueManagerDescriptionRetail'
              : 'userManagement.venueManagerDescription'
          }
        />
      );
    case 'venue_worker':
      return (
        <FormattedMessage
          id={
            shouldUseRetailStrings
              ? 'userManagement.venueWorkerDescriptionRetail'
              : 'userManagement.venueWorkerDescription'
          }
        />
      );
    default:
      return null;
  }
};

const Root = styled.div`
  padding: 16px 24px;
  border-block-start: 1px solid ${cssThemedValue('borderPrimary')};
`;

const RoleDescription = ({ role }: Props) => {
  const isRetailContext = useRetailContext();
  const description = getRoleDescription(role, isRetailContext);
  if (description === null) {
    return null;
  }
  return (
    <Root>
      <Alert variant="info">{description}</Alert>
    </Root>
  );
};

export default RoleDescription;
